import { createEventListener } from '@solid-primitives/event-listener';
import { Accessor } from 'solid-js';

export default function createClickOutside(
  el: Accessor<Element | Element[] | undefined>,
  callback: (e: any) => void,
  ignore?: Accessor<Element | Element[] | undefined>
) {
  // createEffect(() => {
  //   let els = el();
  //   if (!els) return;
  //   if (!(els instanceof Array)) {
  //     els = [els];
  //   }

  //   const onClick = (e: any) => {
  //     let inner = false;
  //     els.forEach((el) => (inner = el.contains(e.target)));
  //     !inner && callback();
  //   };
  //   document.body.addEventListener('click', onClick);
  //   onCleanup(() => {
  //     document.body.removeEventListener('click', onClick);
  //   });
  // });

  createEventListener(
    () => document.body,
    'click',
    (e) => {
      let els = el();
      if (!els) return;
      els = Array.isArray(els) ? els : [els];

      if (ignore) {
        const igEls = ignore();
        if (igEls) {
          const igs = Array.isArray(igEls) ? igEls : [igEls];
          const isIgnore = !igs.every(
            (el) => !el.contains(e.target as Element)
          );
          if (isIgnore) {
            return;
          }
        }
      }

      els.every((el) => !el.contains(e.target as Element)) && callback(e);
    }
  );
}
